import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Minus(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M8.75,17 L27.25,17 C27.6642136,17 28,17.3357864 28,17.75 C28,18.1642136 27.6642136,18.5 27.25,18.5 L8.75,18.5 C8.33578644,18.5 8,18.1642136 8,17.75 C8,17.3357864 8.33578644,17 8.75,17 Z"></path>
    </IconSvg>
  );
}
